import { pick } from 'lodash'

const transformToUpdateDietCategoryDetailsArgs = data =>
  pick(data, ['description', 'position', 'descriptionUrl'])

export default transformToUpdateDietCategoryDetailsArgs
